import React from 'react';
import styles from './commonComponents.module.scss';

export default function SectionSubtitle({ children }) {
  return <span className={styles.subtitle}>{children}</span>;
}
